// OSIS - Planificare Producție - Calendar și optimizarea proceselor de producție cu planificare echipe și comenzi
import React, { useState } from 'react';
import { 
  Calendar, Search, Clock, Users, Plus, Target,
  CheckCircle, AlertTriangle, TrendingUp, Activity,
  BarChart3, FileText, Download, Edit, ArrowRight,
  User, MapPin, Package, Timer, Zap
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const ProductionPlanning = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('toate');
  const [selectedView, setSelectedView] = useState('săptămână');
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isAddPlanModalOpen, setIsAddPlanModalOpen] = useState(false);

  // Mock data specific OSIS - planuri de producție realiste
  const mockProductionPlans = [
    {
      id: 1,
      planName: 'Comandă Rezidențial Predeal - Lot A',
      orderId: 'ORD-2024-0145',
      client: 'SC Predeal Construct SRL',
      startDate: '2024-03-25',
      endDate: '2024-04-08',
      status: 'în progres',
      priority: 'înaltă',
      progress: 65,
      team: 'Echipa Aluminiu',
      teamLeader: 'Maria Ionescu',
      teamSize: 4,
      products: [
        { name: 'proiecte aluminiu 120x150cm', quantity: 24, completed: 18 },
        { name: 'lucrări balcon aluminiu 90x220cm', quantity: 8, completed: 4 },
        { name: 'proiecte aluminiu 100x120cm', quantity: 16, completed: 12 }
      ],
      estimatedHours: 320,
      actualHours: 198,
      efficiency: '92%',
      location: 'Secția Aluminiu',
      materials: ['Profile aluminiu', 'Materiale pardoseală', 'materiale Blastrac'],
      notes: 'Atenție: client solicită livrare anticipată cu 2 zile'
    },
    {
      id: 2,
      planName: 'Proiect Corporativ București Tower',
      orderId: 'ORD-2024-0156',
      client: 'Tower Development SA',
      startDate: '2024-03-28',
      endDate: '2024-05-15',
      status: 'planificat',
      priority: 'înaltă',
      progress: 0,
      team: 'Echipa Mixed epoxidic-Aluminiu',
      teamLeader: 'Ion Popescu',
      teamSize: 6,
      products: [
        { name: 'proiecte epoxidic 5 camere 140x180cm', quantity: 85, completed: 0 },
        { name: 'lucrări intrare aluminiu 100x250cm', quantity: 12, completed: 0 },
        { name: 'proiecte aluminiu 180x200cm', quantity: 45, completed: 0 }
      ],
      estimatedHours: 680,
      actualHours: 0,
      efficiency: '-',
      location: 'Atelier Principal + Secția Aluminiu',
      materials: ['rășini epoxidice 5 camere', 'Profile aluminiu', 'Materiale Low-E', 'materiale HTC'],
      notes: 'Proiect major - planificare în etape'
    },
    {
      id: 3,
      planName: 'Renovare Vila Suceava',
      orderId: 'ORD-2024-0162',
      client: 'Familie Popescu',
      startDate: '2024-03-22',
      endDate: '2024-03-29',
      status: 'finalizat',
      priority: 'normală',
      progress: 100,
      team: 'Echipa epoxidic',
      teamLeader: 'Andrei Munteanu',
      teamSize: 3,
      products: [
        { name: 'proiecte epoxidic 3 camere 120x140cm', quantity: 12, completed: 12 },
        { name: 'lucrare intrare epoxidic 90x210cm', quantity: 1, completed: 1 },
        { name: 'proiecte epoxidic 3 camere 80x100cm', quantity: 6, completed: 6 }
      ],
      estimatedHours: 95,
      actualHours: 89,
      efficiency: '106%',
      location: 'Atelier Principal',
      materials: ['rășini epoxidice 3 camere', 'Materiale pardoseală standard', 'materiale Hoppe'],
      notes: 'Finalizat cu 6 ore mai devreme decât planificat'
    },
    {
      id: 4,
      planName: 'Complex Râșnov - Faza 2',
      orderId: 'ORD-2024-0168',
      client: 'Râșnov Development Group',
      startDate: '2024-04-01',
      endDate: '2024-04-20',
      status: 'în așteptare',
      priority: 'normală',
      progress: 0,
      team: 'Echipa Aluminiu',
      teamLeader: 'Elena Cristea',
      teamSize: 5,
      products: [
        { name: 'proiecte aluminiu 160x180cm', quantity: 32, completed: 0 },
        { name: 'lucrări balcon aluminiu 120x240cm', quantity: 16, completed: 0 },
        { name: 'Jaluzele exterioare aluminiu', quantity: 24, completed: 0 }
      ],
      estimatedHours: 450,
      actualHours: 0,
      efficiency: '-',
      location: 'Secția Aluminiu',
      materials: ['Profile aluminiu', 'beton șlefuit', 'materiale Blastrac', 'Sistem jaluzele'],
      notes: 'În așteptarea confirmării finale de la client'
    },
    {
      id: 5,
      planName: 'Restaurare Pensiune Tradițională',
      orderId: 'ORD-2024-0171',
      client: 'Pensiunea Carpați',
      startDate: '2024-04-05',
      endDate: '2024-04-12',
      status: 'în progres',
      priority: 'scăzută',
      progress: 35,
      team: 'Echipa epoxidic',
      teamLeader: 'Vasile Gheorghiu',
      teamSize: 3,
      products: [
        { name: 'proiecte epoxidic aspect lemn 100x120cm', quantity: 18, completed: 8 },
        { name: 'lucrări epoxidic aspect lemn 85x200cm', quantity: 4, completed: 1 },
        { name: 'proiecte mansardă epoxidic 80x140cm', quantity: 6, completed: 2 }
      ],
      estimatedHours: 180,
      actualHours: 63,
      efficiency: '88%',
      location: 'Atelier Principal',
      materials: ['rășini epoxidice aspect lemn', 'Materiale pardoseală', 'materiale rustică'],
      notes: 'Design special - aspect tradițional'
    }
  ];

  // Filtrare planuri
  const filteredPlans = mockProductionPlans.filter(plan => {
    const matchesSearch = plan.planName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         plan.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         plan.orderId.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterStatus === 'toate' || plan.status === filterStatus;
    
    return matchesSearch && matchesFilter;
  });

  // Statistici KPI
  const totalPlans = mockProductionPlans.length;
  const activePlans = mockProductionPlans.filter(plan => plan.status === 'în progres').length;
  const completedPlans = mockProductionPlans.filter(plan => plan.status === 'finalizat').length;
  const averageEfficiency = Math.round(
    mockProductionPlans
      .filter(plan => plan.efficiency !== '-')
      .reduce((acc, plan) => acc + parseFloat(plan.efficiency.replace('%', '')), 0) / 
      mockProductionPlans.filter(plan => plan.efficiency !== '-').length
  );

  const columns = [
    { 
      key: 'planName', 
      label: 'Plan Producție', 
      render: (plan) => {
        if (!plan) return <span>Eroare: Plan nedefinit</span>;
        return (
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary-100 dark:bg-primary-900/50 rounded-lg">
              <Calendar className="w-5 h-5 text-primary-600" />
            </div>
            <div>
              <div className="font-medium text-gray-900 dark:text-white">{plan.planName || 'Plan fără nume'}</div>
              <div className="text-sm text-gray-500">{plan.orderId || 'N/A'} • {plan.client || 'Client necunoscut'}</div>
            </div>
          </div>
        );
      }
    },
    { 
      key: 'status', 
      label: 'Status', 
      render: (plan) => {
        if (!plan) return <span>Eroare: Plan nedefinit</span>;
        return (
          <Badge 
            variant={
              plan.status === 'finalizat' ? 'success' : 
              plan.status === 'în progres' ? 'info' : 
              plan.status === 'planificat' ? 'warning' : 'default'
            }
          >
            {plan.status === 'finalizat' && <CheckCircle className="w-3 h-3 mr-1" />}
            {plan.status === 'în progres' && <Activity className="w-3 h-3 mr-1" />}
            {plan.status === 'planificat' && <Clock className="w-3 h-3 mr-1" />}
            {plan.status === 'în așteptare' && <Timer className="w-3 h-3 mr-1" />}
            {plan.status ? plan.status.charAt(0).toUpperCase() + plan.status.slice(1) : 'Necunoscut'}
          </Badge>
        );
      }
    },
    { 
      key: 'progress', 
      label: 'Progres', 
      render: (plan) => {
        if (!plan) return <span>Eroare: Plan nedefinit</span>;
        const progress = plan.progress || 0;
        return (
          <div className="flex items-center space-x-3">
            <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-2 w-20">
              <div 
                className={`h-2 rounded-full ${
                  progress === 100 ? 'bg-green-500' :
                  progress >= 50 ? 'bg-blue-500' : 'bg-yellow-500'
                }`}
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <span className="text-sm font-medium">{progress}%</span>
          </div>
        );
      }
    },
    { 
      key: 'team', 
      label: 'Echipă', 
      render: (plan) => {
        if (!plan) return <span>Eroare: Plan nedefinit</span>;
        return (
          <div className="flex items-center space-x-2">
            <div className="flex items-center justify-center w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full">
              <Users className="w-4 h-4 text-gray-600" />
            </div>
            <div>
              <div className="text-sm font-medium">{plan.teamLeader || 'Neasignat'}</div>
              <div className="text-xs text-gray-500">{plan.teamSize || 0} membri</div>
            </div>
          </div>
        );
      }
    },
    { 
      key: 'priority', 
      label: 'Prioritate', 
      render: (plan) => {
        if (!plan) return <span>Eroare: Plan nedefinit</span>;
        return (
          <Badge 
            variant={
              plan.priority === 'înaltă' ? 'error' : 
              plan.priority === 'normală' ? 'warning' : 'default'
            }
          >
            {plan.priority === 'înaltă' && <AlertTriangle className="w-3 h-3 mr-1" />}
            {plan.priority === 'normală' && <Target className="w-3 h-3 mr-1" />}
            {plan.priority ? plan.priority.charAt(0).toUpperCase() + plan.priority.slice(1) : 'Normală'}
          </Badge>
        );
      }
    },
    { 
      key: 'timeline', 
      label: 'Timeline', 
      render: (plan) => {
        if (!plan) return <span>Eroare: Plan nedefinit</span>;
        return (
          <div className="text-sm">
            <div className="flex items-center space-x-2 text-gray-600">
              <Calendar className="w-4 h-4" />
              <span>{plan.startDate || 'Data de start lipsește'}</span>
              <ArrowRight className="w-3 h-3" />
              <span>{plan.endDate || 'Data de sfârșit lipsește'}</span>
            </div>
          </div>
        );
      }
    }
  ];

  const handlePlanDetails = (plan) => {
    if (!plan) {
      console.warn('Plan nedefinit:', plan);
      return;
    }
    setSelectedPlan(plan);
    setIsPlanModalOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Header cu acțiuni */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Planificare Producție</h1>
          <p className="text-gray-600 dark:text-gray-400">Calendar și optimizarea proceselor de producție OSIS</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setIsAddPlanModalOpen(true)}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-4 h-4" />
            <span>Plan Nou</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export Calendar</span>
          </button>
        </div>
      </div>

      {/* KPI-uri (4 cards cu statistici) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card variant="stats" className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">Planuri Active</p>
              <p className="text-3xl font-bold">{activePlans}</p>
            </div>
            <Activity className="w-8 h-8 text-blue-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-green-500 to-green-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Finalizate</p>
              <p className="text-3xl font-bold">{completedPlans}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100">Eficiență Medie</p>
              <p className="text-3xl font-bold">{averageEfficiency}%</p>
            </div>
            <TrendingUp className="w-8 h-8 text-purple-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-orange-500 to-orange-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-orange-100">Total Planuri</p>
              <p className="text-3xl font-bold">{totalPlans}</p>
            </div>
            <Calendar className="w-8 h-8 text-orange-200" />
          </div>
        </Card>
      </div>

      {/* Filtre și căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Căutare planuri, comenzi, clienți..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input pl-10 w-full"
              />
            </div>
          </div>
          
          <div className="sm:w-48">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="input w-full"
            >
              <option value="toate">Toate Statusurile</option>
              <option value="planificat">Planificat</option>
              <option value="în progres">În Progres</option>
              <option value="finalizat">Finalizat</option>
              <option value="în așteptare">În Așteptare</option>
            </select>
          </div>
          
          <div className="sm:w-36">
            <select
              value={selectedView}
              onChange={(e) => setSelectedView(e.target.value)}
              className="input w-full"
            >
              <option value="săptămână">Săptămâna</option>
              <option value="lună">Luna</option>
              <option value="trimestru">Trimestru</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Tabel planuri producție */}
      <Card>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Planuri Producție ({filteredPlans.length})
          </h2>
        </div>
        
        <Table 
          data={filteredPlans}
          columns={columns}
          onRowClick={handlePlanDetails}
        />
      </Card>

      {/* Modal Detalii Plan Producție */}
      <Modal
        isOpen={isPlanModalOpen}
        onClose={() => setIsPlanModalOpen(false)}
        title={selectedPlan ? `${selectedPlan.planName}` : ''}
        size="xl"
      >
        {selectedPlan && (
          <div className="space-y-6">
            {/* Info generală */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Comandă & Client</label>
                  <p className="text-lg font-semibold">{selectedPlan.orderId || 'N/A'}</p>
                  <p className="text-sm text-gray-600">{selectedPlan.client || 'Client necunoscut'}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Echipă Responsabilă</label>
                  <p className="text-lg">{selectedPlan.team || 'Neasignată'}</p>
                  <p className="text-sm text-gray-600">Lider: {selectedPlan.teamLeader || 'Neasignat'} • {selectedPlan.teamSize || 0} membri</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Locație Producție</label>
                  <p className="text-lg font-semibold">{selectedPlan?.location || 'Locație nespecificată'}</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Status & Prioritate</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <Badge 
                      variant={
                        selectedPlan.status === 'finalizat' ? 'success' : 
                        selectedPlan.status === 'în progres' ? 'info' : 'warning'
                      }
                    >
                      {selectedPlan.status ? selectedPlan.status.charAt(0).toUpperCase() + selectedPlan.status.slice(1) : 'Necunoscut'}
                    </Badge>
                    <Badge 
                      variant={
                        selectedPlan.priority === 'înaltă' ? 'error' : 
                        selectedPlan.priority === 'normală' ? 'warning' : 'default'
                      }
                    >
                      {selectedPlan.priority ? selectedPlan.priority.charAt(0).toUpperCase() + selectedPlan.priority.slice(1) : 'Normală'}
                    </Badge>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Progres Total</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-3">
                      <div 
                        className={`h-3 rounded-full ${
                          selectedPlan.progress === 100 ? 'bg-green-500' :
                          selectedPlan.progress >= 50 ? 'bg-blue-500' : 'bg-yellow-500'
                        }`}
                        style={{ width: `${selectedPlan?.progress || 0}%` }}
                      ></div>
                    </div>
                    <span className="text-lg font-semibold">{selectedPlan?.progress || 0}%</span>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Timeline</label>
                  <p className="text-lg font-semibold">{selectedPlan.startDate || 'N/A'} - {selectedPlan.endDate || 'N/A'}</p>
                </div>
              </div>
            </div>

            {/* Produse planificate */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Produse Planificate</h3>
              <div className="space-y-3">
                {selectedPlan?.products?.map((product, index) => (
                  <div key={index} className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="font-medium">{product.name}</h4>
                      <span className="text-sm text-gray-500">
                        {product.completed} / {product.quantity}
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                        <div 
                          className="bg-blue-500 h-2 rounded-full"
                          style={{ width: `${(product.completed / product.quantity) * 100}%` }}
                        ></div>
                      </div>
                      <span className="text-sm font-medium">
                        {Math.round((product.completed / product.quantity) * 100)}%
                      </span>
                    </div>
                  </div>
                )) || <p className="text-gray-500">Nu există produse planificate.</p>}
              </div>
            </div>

            {/* Statistici performanță */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Statistici Performanță</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Clock className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Ore Estimate</span>
                  </div>
                  <p className="text-xl font-bold">{selectedPlan?.estimatedHours || 0}h</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Timer className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Ore Efectuate</span>
                  </div>
                  <p className="text-xl font-bold">{selectedPlan?.actualHours || 0}h</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Zap className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Eficiență</span>
                  </div>
                  <p className="text-xl font-bold">{selectedPlan?.efficiency || 'N/A'}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Users className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Mărimea Echipei</span>
                  </div>
                  <p className="text-xl font-bold">{selectedPlan?.teamSize || 0}</p>
                </div>
              </div>
            </div>

            {/* Materiale necesare */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Materiale Necesare</h3>
              <div className="flex flex-wrap gap-2">
                {selectedPlan?.materials?.map((material, index) => (
                  <Badge key={index} variant="default">
                    <Package className="w-3 h-3 mr-1" />
                    {material}
                  </Badge>
                )) || <p className="text-gray-500">Nu există materiale specificate.</p>}
              </div>
            </div>

            {/* Note și observații */}
            {selectedPlan?.notes && (
              <div className="border-t pt-6">
                <h3 className="text-lg font-semibold mb-2">Note & Observații</h3>
                <p className="text-gray-600 dark:text-gray-400 bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border-l-4 border-yellow-400">
                  {selectedPlan.notes}
                </p>
              </div>
            )}

            {/* Acțiuni */}
            <div className="border-t pt-6">
              <div className="flex flex-wrap gap-3">
                <button className="btn-primary flex items-center space-x-2">
                  <Edit className="w-4 h-4" />
                  <span>Editează Plan</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Users className="w-4 h-4" />
                  <span>Gestionare Echipă</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <BarChart3 className="w-4 h-4" />
                  <span>Raport Progres</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <FileText className="w-4 h-4" />
                  <span>Export PDF</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Plan Nou */}
      <Modal
        isOpen={isAddPlanModalOpen}
        onClose={() => setIsAddPlanModalOpen(false)}
        title="Creează Plan Producție Nou"
        size="xl"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <label className="label">Nume Plan Producție</label>
              <input type="text" className="input" placeholder="ex: Comandă Rezidențial Predeal - Lot B" />
            </div>
            <div>
              <label className="label">ID Comandă</label>
              <input type="text" className="input" placeholder="ex: ORD-2024-0180" />
            </div>
            <div>
              <label className="label">Client</label>
              <input type="text" className="input" placeholder="ex: SC Example SRL" />
            </div>
            <div>
              <label className="label">Data de Start</label>
              <input type="date" className="input" />
            </div>
            <div>
              <label className="label">Data de Finalizare</label>
              <input type="date" className="input" />
            </div>
            <div>
              <label className="label">Echipă Responsabilă</label>
              <select className="input">
                <option>Selectează echipa...</option>
                <option>Echipa epoxidic</option>
                <option>Echipa Aluminiu</option>
                <option>Echipa Mixed epoxidic-Aluminiu</option>
              </select>
            </div>
            <div>
              <label className="label">Lider Echipă</label>
              <select className="input">
                <option>Selectează liderul...</option>
                <option>Ion Popescu</option>
                <option>Maria Ionescu</option>
                <option>Andrei Munteanu</option>
                <option>Elena Cristea</option>
                <option>Vasile Gheorghiu</option>
              </select>
            </div>
            <div>
              <label className="label">Prioritate</label>
              <select className="input">
                <option>Selectează prioritatea...</option>
                <option>înaltă</option>
                <option>normală</option>
                <option>scăzută</option>
              </select>
            </div>
            <div>
              <label className="label">Locație Producție</label>
              <select className="input">
                <option>Selectează locația...</option>
                <option>Atelier Principal</option>
                <option>Secția Aluminiu</option>
                <option>Atelier Principal + Secția Aluminiu</option>
                <option>Linia de Producție</option>
              </select>
            </div>
            <div>
              <label className="label">Ore Estimate</label>
              <input type="number" className="input" placeholder="ex: 320" />
            </div>
            <div className="md:col-span-2">
              <label className="label">Note & Observații</label>
              <textarea className="input" rows="3" placeholder="Note speciale pentru acest plan de producție..."></textarea>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 border-t pt-4">
            <button 
              onClick={() => setIsAddPlanModalOpen(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary">
              Creează Plan
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ProductionPlanning;